export enum VisitatieStatus {
    intake = 10,
    bespreken = 20,
    definitief = 30,
  }